import React from "react";

const InventoryIngredientsModal = ({
  ingredientsModalOpen,
  setIngredientsModalOpen,
  ingredients,
  viewModalItem,
  handleIngredientChange,
  removeIngredientRow,
  addIngredientRow,
  handleSubmitIngredients,
}) => {
  return (
    <>
      {/* Ingredients Edit model */}

      {ingredientsModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
          <div className="bg-white w-[600px] rounded-xl shadow-xl">
            {/* HEADER */}

            <div className="flex justify-between items-center border-b px-5 py-3">
              <h3 className="font-semibold text-lg">Recipe Ingredients</h3>

              <button
                onClick={() => setIngredientsModalOpen(false)}
                className="text-gray-500"
              >
                ✕
              </button>
            </div>

            {/* BODY */}

            <div className="p-5 max-h-[400px] overflow-y-auto">
              {ingredients.length === 0 ? (
                <p className="text-sm text-gray-500">No ingredients found</p>
              ) : (
                <div className="p-6 space-y-6">
                  {/* ITEM HEADER */}

                  <div className="flex items-center gap-3">
                    <img
                      src={viewModalItem.photo}
                      className="w-14 h-14 rounded-lg object-cover"
                    />

                    <div>
                      <h3 className="font-semibold text-lg">
                        {viewModalItem.item_name}
                      </h3>

                      <p className="text-sm text-gray-500">
                        Item ID: {viewModalItem.item_id}
                      </p>
                    </div>
                  </div>

                  {/* EMPTY MESSAGE */}

                  {ingredients.length === 0 && (
                    <div className="border rounded-lg p-8 text-center text-gray-500">
                      No ingredients found for this item.
                      <br />
                      Please start by adding new ingredients below.
                    </div>
                  )}

                  <div>
                    <h4 className="font-semibold mb-3">Add Ingredients</h4>
                    <div className="space-y-3">
                      {ingredients.map((row, index) => (
                        <div
                          key={index}
                          className="grid grid-cols-[1fr_150px_150px_100px] gap-3 items-center"
                        >
                          {/* INGREDIENT */}
                          <input
                            placeholder="e.g. Tomato"
                            value={row.ingredient}
                            onChange={(e) =>
                              handleIngredientChange(
                                index,
                                "ingredient",
                                e.target.value,
                              )
                            }
                            className="border rounded px-3 py-2 text-sm"
                          />

                          {/* QUANTITY */}

                          <input
                            placeholder="e.g. 200"
                            value={row.quantity}
                            onChange={(e) =>
                              handleIngredientChange(
                                index,
                                "quantity",
                                e.target.value,
                              )
                            }
                            className="border rounded px-3 py-2 text-sm"
                          />

                          {/* UNIT */}

                          <input
                            placeholder="e.g. gm/ml"
                            value={row.unit}
                            onChange={(e) =>
                              handleIngredientChange(
                                index,
                                "unit",
                                e.target.value,
                              )
                            }
                            className="border rounded px-3 py-2 text-sm"
                          />

                          {/* REMOVE */}

                          <button
                            onClick={() => removeIngredientRow(index)}
                            className="bg-red-500 text-white px-3 py-2 rounded text-sm"
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>

                    {/* ACTION BUTTONS */}

                    <div className="flex gap-3 mt-4">
                      <button
                        onClick={addIngredientRow}
                        className="border px-4 py-2 rounded text-sm text-blue-600"
                      >
                        + Add Another Row
                      </button>

                      <button className="bg-green-600 text-white px-4 py-2 rounded text-sm">
                        Submit Ingredients
                      </button>

                      {/* <button
  onClick={handleSubmitIngredients}
  className="bg-green-600 text-white px-4 py-2 rounded text-sm"
>
  Submit Ingredients
</button> */}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* FOOTER */}

            <div className="flex justify-end border-t px-5 py-3">
              <button
                onClick={() => setIngredientsModalOpen(false)}
                className="border px-4 py-2 rounded text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InventoryIngredientsModal;
